// extracted by mini-css-extract-plugin
export default {"emptyContainer":"WordsList_emptyContainer__XbOe7","emptyIcon":"WordsList_emptyIcon__8hvf6"};